import React from 'react';

import { SignedOut } from './SignedOut';
import { SignedIn } from './SignedIn';

const Home = props => <>{props.user ? <SignedIn user={props.user} /> : <SignedOut />}</>;

export { Home };
